import { render, staticRenderFns } from "./BonusInput.vue?vue&type=template&id=2af8f642&"
import script from "./BonusInput.vue?vue&type=script&lang=js&"
export * from "./BonusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports